<template>
  <BulkEmployeeActionModal
    :show="show"
    :employees="employees"
    :loading="loading"
    :results="results"
    :title="TITLE"
    :results-title="RESULTS_TITLE"
    :instruction-text="INSTRUCTION_TEXT"
    :button-text="BUTTON_TEXT"
    :loading-text="LOADING_TEXT"
    :status-labels="STATUS_LABELS"
    :success-statuses="SUCCESS_STATUSES"
    @close="$emit('close')"
    @confirm="$emit('send-reminder')"
  />
</template>

<script setup>
import BulkEmployeeActionModal from './BulkEmployeeActionModal.vue';

const TITLE = 'Send Reminder to Sign Acknowledgement';
const RESULTS_TITLE = 'Acknowledgement Reminders Sent';
const INSTRUCTION_TEXT = 'Click "Send Acknowledgement Reminder" to re-send the below employees a link '
  + 'via e-mail to acknowledge their job profiles below.';
const BUTTON_TEXT = 'Send Acknowledgement Reminders';
const LOADING_TEXT = 'Sending Acknowledgement Reminder E-mails...';

const STATUS_LABELS = {
  success: 'Success',
  email_failed: 'Success',
  ack_not_found: 'Acknowledgement Not Found',
  ack_no_email: 'Employee Missing E-mail Address',
};

const SUCCESS_STATUSES = ['success', 'email_failed'];

defineProps({
  show: { type: Boolean, default: false },
  employees: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  results: { type: Array, default: null },
});

defineEmits(['close', 'send-reminder']);
</script>
